import { computed, ref } from 'vue'
const confirmModalData = ref(null)
const isOpen = computed(() => !!confirmModalData.value)

export function useConfirm() {
  const showConfirm = ({
    title = 'Unsaved changes',
    message = "Your changes haven't been saved and will be lost.",
    icon = 'alert-triangle',
    confirmText = 'Discard',
    cancelText = 'Go back',
    continueText = null,
    confirmColor = 'brand',
    cancelColor = 'brand-light',
    continueColor = 'primary',
    onConfirm = () => {},
    onCancel = () => {},
    onContinue = null,
  } = {}) => {
    confirmModalData.value = {
      title,
      message,
      icon,
      confirmText,
      cancelText,
      continueText,
      confirmColor,
      cancelColor,
      continueColor,
      onConfirm,
      onCancel,
      onContinue,
    }
  }

  const closeConfirm = () => {
    confirmModalData.value = null
  }

  // Common confirmation modal presets
  const confirmDelete = (itemName = 'item', onConfirm) => {
    showConfirm({
      title: `Delete ${itemName}`,
      message: `This ${itemName} will be permanently removed.`,
      icon: 'trash',
      confirmText: 'Delete',
      cancelText: 'Keep it',
      onConfirm,
    })
  }

  const confirmLeave = ({ onConfirm, onContinue, onCancel } = {}) => {
    showConfirm({
      title: 'Unsaved changes',
      message: "Your changes haven't been saved and will be lost.",
      icon: 'alert-triangle',
      confirmText: 'Discard',
      cancelText: 'Go back',
      continueText: onContinue ? 'Save & continue' : null,
      onConfirm,
      onCancel,
      onContinue: onContinue
        ? async () => {
            await onConfirm?.()
            await onContinue?.()
          }
        : null,
    })
  }

  return {
    isOpen,
    confirmModalData,
    showConfirm,
    closeConfirm,
    // Preset helpers
    confirmDelete,
    confirmLeave,
  }
}
